module.exports = __webpack_public_path__ + "img/img20.6bb9ee19.png";